/**
 * Audio Consent Dialog
 * Shows audio playback consent dialog after camera permission
 */

/**
 * Audio Consent Dialog class
 */
export class AudioConsentDialog {
  constructor() {
    this.container = null;
    this.isVisible = false;
    this.onConfirmCallback = null;
  }

  /**
   * Initialize dialog
   * @param {HTMLElement} parentElement - Parent element to append to
   */
  init(parentElement) {
    this.container = document.createElement('div');
    this.container.className = 'audio-consent-dialog';

    // Dialog content
    const content = document.createElement('div');
    content.className = 'audio-consent-content';

    // Message
    const message = document.createElement('div');
    message.className = 'audio-consent-message';
    message.textContent = '音声を再生しますか？';

    // Button container
    const buttonContainer = document.createElement('div');
    buttonContainer.className = 'audio-consent-buttons';

    // Muted button (with SVG icon)
    const mutedButton = document.createElement('button');
    mutedButton.className = 'audio-consent-button audio-consent-muted';
    mutedButton.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 16 16">
        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
          <polygon points="1.75 5.75 1.75 10.25 4.25 10.25 8.25 13.25 8.25 2.75 4.25 5.75"/>
          <path d="m14.25 5.75-3.5 4.5m0-4.5 3.5 4.5"/>
        </g>
      </svg>
      <span>ミュート</span>
    `;
    mutedButton.addEventListener('click', () => this.handleChoice(true));

    // Unmuted button (with SVG icon)
    const unmutedButton = document.createElement('button');
    unmutedButton.className = 'audio-consent-button audio-consent-unmuted';
    unmutedButton.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 512 512">
        <path fill="currentColor" fill-rule="evenodd" d="m403.966 426.944l-33.285-26.63c74.193-81.075 74.193-205.015-.001-286.09l33.285-26.628c86.612 96.712 86.61 242.635.001 339.348M319.58 155.105l-33.324 26.659c39.795 42.568 39.794 108.444.001 151.012l33.324 26.658c52.205-58.22 52.205-146.109-.001-204.329m-85.163-69.772l-110.854 87.23H42.667v170.666h81.02l110.73 85.458z"/>
      </svg>
      <span>再生</span>
    `;
    unmutedButton.addEventListener('click', () => this.handleChoice(false));

    buttonContainer.appendChild(mutedButton);
    buttonContainer.appendChild(unmutedButton);

    content.appendChild(message);
    content.appendChild(buttonContainer);
    this.container.appendChild(content);
    parentElement.appendChild(this.container);

    // Initially hidden
    this.container.style.display = 'none';

    console.log('AudioConsentDialog initialized');
  }

  /**
   * Show dialog
   * @param {Function} onConfirm - Callback with user choice (isMuted: boolean)
   */
  show(onConfirm) {
    if (!this.container) return;
    this.onConfirmCallback = onConfirm;
    this.container.style.display = 'flex';
    this.isVisible = true;
  }

  /**
   * Hide dialog
   */
  hide() {
    if (!this.container) return;
    this.container.style.display = 'none';
    this.isVisible = false;
  }

  /**
   * Handle user choice
   * @param {boolean} isMuted - True if user chose muted
   * @private
   */
  handleChoice(isMuted) {
    this.hide();
    if (this.onConfirmCallback) {
      this.onConfirmCallback(isMuted);
    }
  }

  /**
   * Cleanup
   */
  cleanup() {
    if (this.container && this.container.parentElement) {
      this.container.parentElement.removeChild(this.container);
    }
    this.container = null;
    this.onConfirmCallback = null;
    console.log('AudioConsentDialog cleaned up');
  }
}
